module.exports = __webpack_public_path__ + "media/images/pages/ai/icon-model-61af115e5e7acced38b37be04c118388.svg";